import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { Link } from 'react-router-dom';

const AboutPage = () => {
  const timeline = [
    {
      year: '1996',
      title: 'Heuliez (M) Sdn Bhd Founded',
      description:
        'Our journey began with the establishment of Heuliez (M) Sdn Bhd, laying the foundation in property development.',
      icon: 'ri-flag-line',
    },
    {
      year: '2006',
      title: 'MSC Status Awarded',
      description:
        'Drixem Sdn Bhd received its MSC Status Company award, marking our entry into technology, advertising, and digital innovation.',
      icon: 'ri-award-line',
    },
    {
      year: '2014',
      title: 'Palm Cooking Oil Business',
      description:
        'Drixem became involved in the palm cooking oil business, entering the palm oil industry with JAKIM Halal and MPOB certifications based in Seremban, Negeri Sembilan.',
      icon: 'ri-plant-line',
    },
    {
      year: '2018',
      title: 'Manufacturing Expansion',
      description:
        'Launched Drixem Nexus Manufacturing Sdn Bhd, expanding into OEM contract manufacturing, palm cooking oil packaging, and AP Export permit operations.',
      icon: 'ri-settings-3-line',
    },
    {
      year: '2020',
      title: 'Global Export Trade',
      description:
        'Established Aravion Zeus Sdn Bhd to drive B2B export trade, connecting Malaysian products to global markets across five continents.',
      icon: 'ri-ship-line',
    },
    {
      year: '2024',
      title: 'Physical AI Division',
      description:
        'Launched Nexa Prime Sdn Bhd as the dedicated Physical AI and IT Tech arm, integrating AI with hardware, logistics, and industrial infrastructure across all divisions — a field proven by Nvidia and Amazon.',
      icon: 'ri-robot-line',
    },
    {
      year: '2026',
      title: 'Drixem Group Consolidated',
      description:
        'All business entities consolidated under one unified Drixem Group, forming a Closed-Loop Ecosystem — a Sustainable Economic Business Circle spanning Palm Oil, Manufacturing, Property Development, B2B Export Trade, Advertising & Marketing, and Physical AI IT Tech.',
      icon: 'ri-building-4-line',
    },
  ];

  const values = [
    {
      icon: 'ri-leaf-line',
      title: 'Sustainability',
      description:
        'Committed to environmental stewardship and sustainable practices across all operations.',
    },
    {
      icon: 'ri-team-line',
      title: 'Innovation',
      description:
        'Embracing Physical AI and cutting-edge technology to transform real-world business operations.',
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Integrity',
      description:
        'Maintaining the highest standards of quality, compliance, and ethical business practices.',
    },
    {
      icon: 'ri-trophy-line',
      title: 'Equity Rewards to High Achiever',
      description:
        'Recognising and rewarding top performers with equity participation, ensuring alignment between individual excellence and company growth.',
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      <section className="relative pt-0 pb-0">
        <div className="relative w-full min-h-[320px] md:min-h-[420px]">
          <img
            src="https://public.readdy.ai/ai/img_res/f65e83215f488f2e1f3cf6801fb8aead.jpg"
            alt="About Drixem Group - Eco Friendly Corporate Headquarters"
            title="About Drixem Group"
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/60"></div>
          <div className="relative z-10 flex items-center justify-center min-h-[320px] md:min-h-[420px] py-20 px-4 sm:px-6">
            <div className="text-center w-full max-w-4xl mx-auto">
              <h1 className="text-2xl sm:text-4xl md:text-5xl lg:text-6xl font-display font-bold text-white mb-3 sm:mb-4 leading-tight">
                About Drixem Group
              </h1>
              <p className="text-base sm:text-xl md:text-2xl font-display text-accent-200">
                &ldquo;We Create Our Own Destiny&rdquo;
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="max-w-5xl mx-auto px-6 lg:px-8 text-center">
          <p className="text-xl text-gray-600 leading-relaxed">
            Our history began with{' '}
            <strong>Heuliez (M) Sdn Bhd, established since 1996</strong>, followed
            by{' '}
            <strong>
              Drixem Sdn Bhd receiving its MSC Status Company award in 2006
            </strong>
            . Today, Drixem Group is a diversified Malaysian business
            conglomerate spanning{' '}
            <strong>Palm Oil</strong>, <strong>Manufacturing</strong>,{' '}
            <strong>Property Development</strong>,{' '}
            <strong>B2B Export Trade</strong>,{' '}
            <strong>Advertising &amp; Marketing</strong>, and{' '}
            <strong>Physical AI IT Tech</strong> — all operating within a <strong>Sustainable Economic Business Circle</strong>.
          </p>
        </div>
      </section>

      {/* Vision Section - Physical AI */}
      <section className="py-16 bg-gradient-to-r from-primary-600 to-primary-800 relative overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-0 left-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
          <div className="absolute bottom-0 right-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
        </div>
        <div className="max-w-5xl mx-auto px-6 lg:px-8 text-center relative z-10">
          <div className="inline-flex items-center space-x-2 px-4 py-2 bg-white/10 rounded-full mb-6">
            <i className="ri-eye-line text-white"></i>
            <span className="text-sm text-white/90 font-medium">Our Vision</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-display font-bold text-white mb-6">
            Physical AI — The Core of Our Business
          </h2>
          <p className="text-xl text-white/85 max-w-3xl mx-auto leading-relaxed mb-8">
            <strong>Physical AI</strong> is the integration of artificial intelligence with physical business operations — embedding AI into <strong>hardware, logistics, and industrial infrastructure</strong> at massive scale. While many companies use AI for software, Drixem Group has successfully applied Physical AI across all six divisions, transforming real-world operations.
          </p>
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 sm:p-8 max-w-2xl mx-auto mb-8">
            <p className="text-white/90 text-lg leading-relaxed">
              This approach is proven by industry leaders like <strong>Nvidia</strong> and <strong>Amazon</strong>, who have demonstrated that the future of AI lies not just in software, but in transforming physical business operations. <strong>Nexa Prime Sdn Bhd</strong> leads this initiative across the entire Drixem Group ecosystem.
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-3xl mx-auto mb-8">
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4">
              <div className="text-2xl font-bold text-white mb-1">AI + Hardware</div>
              <p className="text-white/70 text-sm">Smart manufacturing &amp; automation</p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4">
              <div className="text-2xl font-bold text-white mb-1">AI + Logistics</div>
              <p className="text-white/70 text-sm">Optimised supply chain &amp; export</p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4">
              <div className="text-2xl font-bold text-white mb-1">AI + Industry</div>
              <p className="text-white/70 text-sm">Intelligent infrastructure at scale</p>
            </div>
          </div>
          <p className="text-2xl font-display text-accent-200 italic">
            &ldquo;We Create Our Own Destiny&rdquo;
          </p>
        </div>
      </section>

      {/* Public Listing Vision */}
      <section className="py-16 bg-gradient-to-b from-gray-50 to-white">
        <div className="max-w-5xl mx-auto px-6 lg:px-8 text-center">
          <div className="inline-flex items-center space-x-2 px-4 py-2 bg-primary-50 rounded-full mb-6">
            <i className="ri-stock-line text-primary-600"></i>
            <span className="text-sm text-primary-700 font-medium">Our Ambition</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-display font-bold text-gray-900 mb-6">
            Public Listing of Subsidiaries
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Our ultimate ambition is <strong>public listing on one or more of our subsidiaries</strong> while maintaining <strong>Drixem Group as a private company</strong> — delivering world-class governance, transparency, and exceptional returns for our investors.
          </p>
        </div>
      </section>

      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-display font-bold text-gray-900 mb-6">
              Our Journey
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Three decades of growth from property development to a
              Physical AI-powered business conglomerate
            </p>
          </div>

          <div className="relative">
            <div className="absolute left-1/2 transform -translate-x-1/2 h-full w-1 bg-primary-200 hidden md:block"></div>

            <div className="space-y-12">
              {timeline.map((item, index) => (
                <div
                  key={index}
                  className={`flex flex-col md:flex-row items-center ${
                    index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'
                  }`}
                >
                  <div
                    className={`w-full md:w-1/2 ${
                      index % 2 === 0
                        ? 'md:pr-12 md:text-right'
                        : 'md:pl-12 md:text-left'
                    }`}
                  >
                    <div className={`bg-white border border-gray-200 rounded-2xl p-6 shadow-lg hover:shadow-xl transition-shadow ${index === timeline.length - 1 ? 'ring-2 ring-primary-500 ring-offset-2' : ''}`}>
                      <div className="text-3xl font-bold text-primary-600 mb-2">
                        {item.year}
                      </div>
                      <h3 className="text-xl font-bold text-gray-900 mb-3">
                        {item.title}
                      </h3>
                      <p className="text-gray-600">{item.description}</p>
                    </div>
                  </div>

                  <div className="relative z-10 my-4 md:my-0">
                    <div className={`w-16 h-16 flex items-center justify-center rounded-full border-4 border-white shadow-lg ${index === timeline.length - 1 ? 'bg-accent-500' : 'bg-primary-600'}`}>
                      <i className={`${item.icon} text-2xl text-white`}></i>
                    </div>
                  </div>

                  <div className="hidden md:block w-1/2"></div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="py-24 bg-gradient-to-b from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-display font-bold text-gray-900 mb-6">
              Our Values
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              The principles that guide our transformation and drive our success
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {values.map((value, index) => (
              <div
                key={index}
                className="bg-white border border-gray-200 rounded-2xl p-8 text-center hover:shadow-xl transition-all hover:-translate-y-2"
              >
                <div className="w-16 h-16 flex items-center justify-center bg-primary-100 rounded-full mx-auto mb-6">
                  <i
                    className={`${value.icon} text-3xl text-primary-600`}
                  ></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-4">
                  {value.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {value.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default AboutPage;
